import { Link } from 'react-router';
import { canDecide, useSession } from '../auth/session';
import { Chip } from './ui';
import type { ReactNode } from 'react';

export interface Crumb { label: string; to?: string }

export interface HeaderProps {
  crumbs?: Crumb[];
  right?: ReactNode;
  /** Starts the tour for the screen the header is on; the link only shows where a screen has one */
  onTour?: () => void;
}

export function Header({ crumbs = [], right, onTour }: HeaderProps) {
  const { user, logout } = useSession();
  return (
    <header className="header">
      <Link to="/projects" className="brand"><i />Proofroom</Link>
      {crumbs.length > 0 && (
        <nav className="crumbs" aria-label="Breadcrumb">
          {crumbs.map((c, i) => (
            <span key={i} style={{ display: 'contents' }}>
              <span className="sep">/</span>
              {c.to ? <Link to={c.to}>{c.label}</Link> : <span>{c.label}</span>}
            </span>
          ))}
        </nav>
      )}
      <div className="spacer" />
      {right}
      {onTour && <button className="btn sm ghost" onClick={onTour}>Show me around</button>}
      {user && (
        <div className="user">
          <span>{user.name}</span>
          <Chip kind="role">{user.role}</Chip>
          <Link className="btn sm ghost" to="/guide" data-tour="guide">Guide</Link>
          {canDecide(user) && <Link className="btn sm ghost" to="/pair" data-tour="pair">Link InDesign</Link>}
          {user.role === 'admin' && <Link className="btn sm ghost" to="/users">Users</Link>}
          <Link className="btn sm ghost" to="/notifications" data-tour="notifications">Notifications</Link>
          <button className="btn sm ghost" onClick={() => void logout()}>Sign out</button>
        </div>
      )}
    </header>
  );
}
